import type { Ref, SelectHTMLAttributes } from "react";

import { CHEVRON_DOWN_MASK } from "../icons";
import styles from "./Select.module.css";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** React 19 passes `ref` as a prop; it reaches the native element. */
  ref?: Ref<HTMLSelectElement>;
}

/**
 * Every native list of the app in one look (Task 11, UX-Gutachten 1, B-16):
 * the stage, customer and type lists, the calculation's parameters, the
 * handover's person, the record's direction — each drew the operating
 * system's arrow and looked exactly as before „Stahl".
 *
 * Still the native `<select>`: its role, its keys, its list on the phone and
 * its name from a `<label>` stay the browser's, and every attribute and the
 * `ref` reach it. Only the look is ours — the browser's own drawing off, the
 * control's 10 px corner and the toolbar's 40 px as a floor (a site's own
 * compact height wins), and a chevron after it: the icon from `icons.tsx` as
 * a mask, painted in a token (`Select.module.css`), hidden from screen
 * readers. tokens.test.ts holds that no other file writes a `<select>`.
 */
export function Select({ ref, ...props }: SelectProps) {
  return (
    <span className={styles.wrap}>
      <select ref={ref} {...props} />
      <span className={styles.chevron} style={{ maskImage: CHEVRON_DOWN_MASK }} aria-hidden="true" />
    </span>
  );
}
